import { AbortControllerManager } from '../abortControllerManager';
import { authClient } from '../client';
import type {
  IListVitalsResponse,
  ISubmitVitalsBody,
  IVitalsResponse,
} from '@/types/medwand';

class MedwandApi extends AbortControllerManager {
  private readonly MEDWAND_URL = '/v2/medwand';

  constructor() {
    super();
  }

  getVitals(): Promise<IListVitalsResponse> {
    const signal = this.createAbortController('getVitals');
    return authClient.get(`${this.MEDWAND_URL}/vitals`, { signal });
  }

  submitVitals(body: ISubmitVitalsBody): Promise<IVitalsResponse> {
    const signal = this.createAbortController('submitVitals');
    return authClient.post(`${this.MEDWAND_URL}/vitals`, body, { signal });
  }
}

export const medwandApi = new MedwandApi();
